
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
/* Apply component specific CSS */
:host{
  --background-color:var(--cyan-near-lighten-2);
  --text-color:var(--blue-responsible-darken-2);
  box-sizing: border-box;
  display: block;
  width: 100%;
  overflow: hidden;
  border-radius: 1rem;
  border:1px solid #BBDDF2;
  border:1px solid var(--background-color, #BBDDF2);
  box-shadow:0 6px 6px 0 #00000040;
}

::slotted([slot="example"]) h4 {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: var(--fw-bold);
}

.idb-expandable-card__content {
  min-height: 164px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  text-align: left;
  transition-property: color, background-color, border-color, fill, stroke, -webkit-text-decoration-color;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, -webkit-text-decoration-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

@media (min-width: 768px) {

  .idb-expandable-card__content {
    min-height: 244px;
  }
}

@media (min-width: 1280px) {

  .idb-expandable-card__content {
    padding: 0.5rem;
  }
}

@media (min-width: 1440px) {

  .idb-expandable-card__content {
    min-height: 164px;
  }

  .idb-expandable-card__content {
    padding: 1rem;
  }
}

.idb-expandable-card__content{
  background-color:#BBDDF2;
  background-color:var(--background-color, #BBDDF2);
  color:#00374E;
  color:var(--text-color, #00374E);
  word-break:break-word;
}

@media (min-width: 2300px){
  .idb-expandable-card__content{
    min-height:151px;
  }
}

.idb-expandable-card__content.bg-hover:hover {
  background-color: var(--neutral-white);
}

.idb-expandable-card__content slot {
  display: block;
}

.idb-expandable-card__title {
  margin-bottom: 1rem;
  margin-top: 0.5rem;
  cursor: pointer;
  font-size: var(--fs-3xl);
  line-height: var(--lh-3xl);
  font-weight: var(--fw-semibold);
  color: var(--blue-responsible-darken-2);
}

.idb-expandable-card__title:hover {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.idb-expandable-card__description-container {
  box-sizing: border-box;
  height: 0px;
  overflow: hidden;
  transition:height 0.5s ease;
}

.idb-expandable-card__subtitle {
  margin-bottom: 1rem;
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
  font-weight: var(--fw-normal);
}

.idb-expandable-card__acronym {
  margin-bottom: 1rem;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: var(--fw-bold);
}

.idb-expandable-card__example, .idb-expandable-card__summary {
  margin-bottom: 1rem;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: var(--fw-normal);
}

.idb-expandable-card__cta-link {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 0.25rem;
}

.idb-expandable-card__cta-link > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}

.idb-expandable-card__cta-link {
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: var(--fs-base);
  line-height: var(--lh-base);
  font-weight: var(--fw-bold);
}

:host([is-expanded="true"]) {
  height: 100%;
  box-shadow:0 4px 4px 0 #00000040;
}

:host([is-expanded="true"]) .idb-expandable-card__content {
  display: flex;
}

:host([is-expanded="true"]) .idb-expandable-card__content {
  height: 100%;
}

:host([is-expanded="true"]) .idb-expandable-card__content {
  flex-direction: column;
}

:host([is-expanded="true"]) .idb-expandable-card__content {
  padding-left: 1rem;
  padding-right: 1rem;
}

:host([is-expanded="true"]) .idb-expandable-card__content {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

:host([is-expanded="true"]) .idb-expandable-card__description-container {
  height: auto;
}

:host([is-expanded="true"]) .idb-expandable-card__title {
  cursor: default;
}

:host([is-expanded="true"]) .idb-expandable-card__title {
  font-size: var(--fs-2xl);
  line-height: var(--lh-2xl);
}

:host([is-expanded="true"]) .idb-expandable-card__title:hover {
  -webkit-text-decoration-line: none;
          text-decoration-line: none;
}

:host([is-expanded="true"]) .idb-expandable-card__subtitle {
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
}

:host([is-expanded="true"]) .idb-expandable-card__cta-link {
  margin-top: auto;
}

:host([is-catalog-card="true"]) .idb-expandable-card__content {
  min-height: 100%;
}

@media (min-width: 768px) {

  :host([is-catalog-card="true"]) .idb-expandable-card__content {
    max-height: 400px;
  }
}

@media (min-width: 1440px) {

  :host([is-catalog-card="true"]) .idb-expandable-card__content {
    max-height: 350px;
  }
}

@media (min-width: 2180px) {

  :host([is-catalog-card="true"]) .idb-expandable-card__content {
    max-height: 300px;
  }
}

@media (min-width: 768px) {

  :host([is-catalog-card="true"]) .idb-expandable-card__content {
    min-height: 400px;
  }
}

@media (min-width: 1440px) {

  :host([is-catalog-card="true"]) .idb-expandable-card__content {
    min-height: 350px;
  }
}

@media (min-width: 2180px) {

  :host([is-catalog-card="true"]) .idb-expandable-card__content {
    min-height: 300px;
  }
}

:host([is-catalog-card="true"]) .idb-expandable-card__title {
  font-size: var(--fs-xl);
  line-height: var(--lh-xl);
}

:host([is-catalog-card="true"]) .idb-expandable-card__subtitle {
  font-size: var(--fs-lg);
  line-height: var(--lh-lg);
}

:host([is-catalog-card="true"]) .idb-expandable-card__acronym, :host([is-catalog-card="true"]) .idb-expandable-card__summary, :host([is-catalog-card="true"]) .idb-expandable-card__cta-link {
  font-size: var(--fs-base);
  line-height: var(--lh-base);
}
`;